var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { parseTime } from '../helpers/helpers';
import './videoClips.scss';
export var VideoClips = function (props) {
    var isOpen = props.isOpen, clips = props.clips, onClipClick = props.onClipClick;
    var handleVideoClick = function (e, clip) {
        e.stopPropagation();
        onClipClick(clip);
    };
    var videoClipsClassName = classNames('video-clips-wrapper', { open: isOpen });
    return (_jsx("ul", __assign({ className: videoClipsClassName }, { children: clips.map(function (clip) {
            var toText = parseTime(clip.timeCode).toText;
            return (_jsxs("li", __assign({ className: 'video-clips-item', onClick: function (e) { return handleVideoClick(e, clip); } }, { children: [_jsx("p", __assign({ className: 'video-clip-name' }, { children: clip.name })), _jsx("p", __assign({ className: 'video-clip-time-reference' }, { children: toText }))] }), clip.timeCode));
        }) })));
};
